import { useEffect, useState } from 'react';
import AdminCard from '../../../components/admin/AdminCard';
import useProject from '../hooks/useProject';
import ProjectUpdateLayoutForm from './ProjectUpdateLayoutForm';
import { InvestorProjectDetail } from '../models/investors';

interface Props {
  projectId: string;
}

const ProjectUpdateLayoutCard = ({ projectId }: Props) => {
  const { doProjectInfo } = useProject();

  const [project, setProject] = useState<InvestorProjectDetail>();

  const loadProject = async () => {
    setProject(await doProjectInfo(projectId));
  };

  useEffect(() => {
    loadProject().then().catch();
  }, [projectId]);
  return (
    <AdminCard
      title="Actualización de layout en marketplace"
      children={
        project ? (
          <ProjectUpdateLayoutForm projectId={projectId} project={project} />
        ) : (
          <p>Cargando...</p>
        )
      }
    />
  );
};

export default ProjectUpdateLayoutCard;
